import { FormField } from '@weirgroup/weir-dls'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useDarkMode } from '../../../hooks/use-darkmode'
interface Props {
    list: any
    isNonEsco?: boolean
    isEditing?: boolean
    setStockNumberValue?: Dispatch<SetStateAction<string>>
    setMachineNumberValue?: Dispatch<SetStateAction<string>>
    setAttachmentTypeValue?: Dispatch<SetStateAction<string>>
    setModelValue?: Dispatch<SetStateAction<string>>
    setCapacityValue?: Dispatch<SetStateAction<string>>
    setManufacturerValue?: Dispatch<SetStateAction<string>>
    setMakeValue?: Dispatch<SetStateAction<string>>
    setClassValue?: Dispatch<SetStateAction<string>>
    setLipWidthValue?: Dispatch<SetStateAction<string>>
    stockNumberValue?: string;
    machineNumberValue?: string;
    attachmentTypeValue?: string;
    modelValue?: string;
    capacityValue?: string;
    manufacturerValue?: string;
    makeValue?: string;
    classValue?: string;
    lipWidthValue?: string;
}

export const GroupFormField = (props: Props) => {
    const {
        list,
        isEditing,
        setStockNumberValue,
        setMachineNumberValue,
        setAttachmentTypeValue,
        setModelValue,
        setCapacityValue,
        setManufacturerValue,
        setMakeValue,
        setClassValue,
        setLipWidthValue,
        isNonEsco
    } = props

    const [titles, setTitles] = useState<any>([])
    const {darkMode} = useDarkMode()
    const isFormFieldInEditMode = (itemTitle: string, isNonEsco?: boolean) => {
        const onlyEscoAssetFields: string[] = ["machine number", "stock number"];
        const notAllowedToEdit: string[] = ["last scan"];
        if (onlyEscoAssetFields.includes(itemTitle) && isEditing) return true;
        if (!onlyEscoAssetFields.includes(itemTitle) && isEditing && isNonEsco && !notAllowedToEdit.includes(itemTitle)) return true;
        return false
    }

    const handleOnChange = (event: any, item: string) => {
        if (isEditing) {
            const val = event.target.value;
            if (item === 'stock number' && setStockNumberValue) {
                setStockNumberValue(val)
            }
            if (item === 'machine number' && setMachineNumberValue) {
                setMachineNumberValue(val)
            }
            if (item === 'attachment type' && setAttachmentTypeValue) {
                setAttachmentTypeValue(val)
            }
            if (item === 'model' && setModelValue) {
                setModelValue(val)
            }
            if (item === 'capacity' && setCapacityValue) {
                setCapacityValue(val)
            }
            if (item === 'manufacturer' && setManufacturerValue) {
                setManufacturerValue(val)
            }
            if (item === 'make' && setMakeValue) {
                setMakeValue(val)
            }
            if (item === 'class' && setClassValue) {
                setClassValue(val)
            }
            if (item === 'lip width' && setLipWidthValue) {
                setLipWidthValue(val)
            }
        }
    }

    const convertToObject = (arr: any) => {
        let converted = arr.map((item: any, i: any) => ({
            title: item,
            id: i + 1,
        }))
        return converted
    }

    const getTitles = (list: any) => {
        let replacedTitles
        if (list.length == undefined) {
            const keys = Object.keys(list)
            replacedTitles = keys.map((item: any) => {
                if (item.includes('_')) {
                    const replaced = item.replace('_', ' ')
                    return replaced
                } else {
                    return item
                }
            })
        } else {
            replacedTitles = list
        }
        return convertToObject(replacedTitles)
    }

    useEffect(() => {
        setTitles(getTitles(list))
    }, [list])
    return (
        <div className='form-field-container'>
            {titles.map((item: any) => {
                let value = Object.values(list)[item.id - 1];
                switch (item.title.toLowerCase()) {
                    case 'stock number':
                        value = props.stockNumberValue ?? value;
                        break;
                    case 'machine number':
                        value = props.machineNumberValue ?? value;
                        break;
                    case 'attachment type':
                        value = props.attachmentTypeValue ?? value;
                        break;
                    case 'model':
                        value = props.modelValue ?? value;
                        break;
                    case 'capacity':
                        value = props.capacityValue ?? value;
                        break;
                    case 'manufacturer':
                        value = props.manufacturerValue ?? value;
                        break;
                    case 'make':
                        value = props.makeValue ?? value;
                        break;
                    case 'class':
                        value = props.classValue ?? value;
                        break;
                    case 'lip width':
                        value = props.lipWidthValue ?? value;
                        break;
                    default:
                        break;
                }
                return (
                    <FormField
                        darkMode={darkMode}
                        key={item.id}
                        name="InputBox"
                        label={item.title}
                        readonly={!isFormFieldInEditMode(item.title, isNonEsco)}
                        size={'sm'}
                        width={'100%'}
                        value={value}
                        fullWidth
                        onChange={(e: any) => handleOnChange(e, item.title)}
                        full
                        applyModalInternalGrid={true}
                        modalType={'large'}
                    />
                )
            })}
        </div>
    )
}
